import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

export const slideExpandIn = trigger('slideExpandIn', [
  transition(':enter', [
    style({ height: 0, opacity: 0, transform: 'translateY(-50%)' }),
    animate(
      '500ms ease-out',
      style({ height: '*', opacity: 1, transform: 'translateY(0)' })
    ),
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1, transform: 'translateY(0)' }),
    animate(
      '500ms ease-in',
      style({ height: 0, opacity: 0, transform: 'translateY(-50%)' })
    ),
  ]),
]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('250ms 500ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    animate('250ms ease-out', style({ opacity: 0, transform: 'translateY(-50%)' }))
  ])
]);

export const expandCollapse = trigger('expandCollapse', [
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate('500ms ease-in', style({ height: '*', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),
    animate('500ms ease-out', style({ height: 0, opacity: 0 })),
  ]),
]);

export const riseAnimation = trigger('rise', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(12px)' }),
    animate('300ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
  ])
]);

export const heroInAnimation = trigger('heroIn', [
  transition(':enter', [
    query('.hero-item', [
      style({ opacity: 0, transform: 'translateY(14px)' }),
      stagger(80, [
        animate('420ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ], { optional: true })
  ])
]);

export const tiersInAnimation = trigger('tiersIn', [
  transition(':enter', [
    query('.tier-col', [
      style({ opacity: 0, transform: 'translateY(20px)' }),
      stagger(100, [
        animate('480ms 200ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ], { optional: true })
  ])
]);

export const sectionsInAnimation = trigger('sectionsIn', [
  transition(':enter', [
    query('.compare-section', [
      style({ opacity: 0, transform: 'translateY(12px)' }),
      stagger(70, [
        animate('360ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ], { optional: true })
  ])
]);

export const staggerCardsAnimation = trigger('staggerCards', [
  transition(':enter', [
    query('article', [
      style({ opacity: 0, transform: 'translateY(24px)' }),
      stagger(120, [
        animate('420ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ], { optional: true })
  ])
]);

export const pricingFaqExpandCollapseAnimation = trigger('expandCollapse', [
  transition(':enter', [
    style({ height: '0', opacity: 0, marginTop: '0' }),
    animate('220ms cubic-bezier(0.22, 1, 0.36, 1)', style({ height: '*', opacity: 1, marginTop: '*' }))
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),
    animate('180ms cubic-bezier(0.4, 0, 0.2, 1)', style({ height: '0', opacity: 0, marginTop: '0' }))
  ])
]);

export const dialogRiseAnimation = trigger('rise', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(16px) scale(0.98)' }),
    animate('300ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
  ])
]);

export const dialogRiseSlowAnimation = trigger('rise', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(16px) scale(0.98)' }),
    animate('320ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
  ])
]);

export const dialogRiseWithLeaveAnimation = trigger('rise', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(16px) scale(0.98)' }),
    animate('300ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
  ]),
  transition(':leave', [
    animate('180ms ease-in', style({ opacity: 0, transform: 'translateY(8px) scale(0.98)' }))
  ])
]);

export const purchaseStageSwitchAnimation = trigger('stageSwitch', [
  transition('* <=> *', [
    query(':enter', [style({ opacity: 0, transform: 'translateX(12px)' })], { optional: true }),
    query(':leave', [
      animate('180ms ease-in', style({ opacity: 0, transform: 'translateX(-12px)', position: 'absolute', inset: '0' }))
    ], { optional: true }),
    query(':enter', [
      animate('260ms 60ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateX(0)' }))
    ], { optional: true })
  ])
]);

export const purchaseCheckPopAnimation = trigger('checkPop', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.4)' }),
    animate('420ms 100ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ opacity: 1, transform: 'scale(1)' }))
  ])
]);

export const sparklePopAnimation = trigger('sparklePop', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.4) rotate(-20deg)' }),
    animate('500ms 100ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ opacity: 1, transform: 'scale(1) rotate(0)' }))
  ])
]);

export const bannerSlideDownAnimation = trigger('slideDown', [
  transition(':enter', [
    style({ transform: 'translateY(-100%)', opacity: 0 }),
    animate('300ms cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateY(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
  ])
]);

export const toastSlideUpAnimation = trigger('slideUp', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(20px)' }),
    animate('260ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
  ])
]);

export const overlayFadeAnimation = trigger('fade', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('300ms ease-out', style({ opacity: 1 }))
  ])
]);

export const overlayCenterRiseAnimation = trigger('rise', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translate(-50%, calc(-50% + 24px))' }),
    animate('400ms cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translate(-50%, -50%)' }))
  ])
]);
